import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "indesign-server"
    }}>{`InDesign Server`}</h1>
    <p>{`Adobe InDesign Server software is a layout and composition engine that powers automated publishing solutions. InDesign Server is based on the desktop version of InDesign but has no built-in user interface.`}</p>
    <p>{`Start by `}<a parentName="p" {...{
        "href": "https://helpx.adobe.com/in/indesign/using/indesign-server.html"
      }}>{`learning more InDesign Server`}</a>{` and set up your local environment to `}<a parentName="p" {...{
        "href": "../../scripts/getting-started/"
      }}>{`get started with UXP scripts`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      